var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isNotEmpty
    ? _c(
        "div",
        {
          staticClass: "details-panel details-panel__white  mb-1",
          attrs: { id: "singleUpgradeBox_" + _vm.product },
        },
        [
          _c("div", { staticClass: "details-panel__body--header" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.getTranslation(
                    "single-upgrade-vue",
                    "single_upgrade_product",
                    { name: _vm.products[_vm.product].title }
                  )
                ) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "details-panel__body" }, [
            _vm._v(
              "\n\n            " +
                _vm._s(
                  _vm.getTranslation(
                    "single-upgrade-vue",
                    "upgrade_perpetual_licences"
                  )
                ) +
                "\n            "
            ),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "custom-control custom-checkbox b-custom-control-lg",
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.productStatus,
                      expression: "productStatus",
                    },
                  ],
                  staticClass: "custom-control-input",
                  attrs: {
                    type: "checkbox",
                    id: "singleUpgrade_" + _vm.product,
                    value: "1",
                    name: "singleUpgradeChecked[" + _vm.product + "]",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.productStatus)
                      ? _vm._i(_vm.productStatus, "1") > -1
                      : _vm.productStatus,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.toggleProduct()
                    },
                    change: function ($event) {
                      var $$a = _vm.productStatus,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = "1",
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.productStatus = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.productStatus = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.productStatus = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "custom-control-label d-flex flex-wrap",
                    attrs: { for: "singleUpgrade_" + _vm.product },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.getTranslation(
                            "single-upgrade-vue",
                            "purchase_single_upgrade"
                          )
                        ) +
                        "\n                    "
                    ),
                    _c("span", { staticClass: "ml-auto text-black" }, [
                      _vm._v(
                        _vm._s(
                          _vm.priceFormat(
                            _vm.singleUpgradeDisplayPrice,
                            true,
                            true
                          )
                        )
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.checkCannotPurchase && 0
                  ? _c("div", { staticClass: "note note-warning mt-2" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.getTranslation(
                              "single-upgrade-vue",
                              "no_licences_selected_for_upgrade"
                            )
                          ) +
                          "\n                "
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            typeof _vm.programData != "undefined"
              ? _c(
                  "div",
                  [
                    _c("div", { staticClass: "details-panel__body--content" }, [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle",
                              value: "singleUpgradeCollapse_" + _vm.product,
                              expression: "'singleUpgradeCollapse_' + product",
                            },
                          ],
                          staticClass: "details-panel__body--trigger",
                          staticStyle: {
                            "max-width": "201px",
                            "white-space": "nowrap",
                          },
                          attrs: { href: "javascript:;" },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.getTranslation(
                                  "single-upgrade-vue",
                                  "selected_programs"
                                )
                              ) +
                              "\n                        "
                          ),
                          _c("span", { staticClass: "collapse-icon" }, [
                            _c(
                              "svg",
                              {
                                staticClass:
                                  "svg-inline--fa fa-caret-down fa-w-10 fa-2x",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 320 512",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    fill: "currentColor",
                                    d: "M287.968 160H32.038c-28.425 0-42.767 34.488-22.627 54.627l127.962 128c12.496 12.496 32.758 12.497 45.255 0l127.968-128C330.695 194.528 316.45 160 287.968 160zM160 320L32 192h256L160 320z",
                                  },
                                }),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-collapse",
                      {
                        staticClass: "details-panel__body--collapse",
                        attrs: { id: "singleUpgradeCollapse_" + _vm.product },
                      },
                      _vm._l(_vm.existingKeys, function (key) {
                        return _vm.hasLicences(key.key_id)
                          ? _c(
                              "div",
                              { staticClass: "col-12 view-extras" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-checkbox",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.keyStatus[key.key_id],
                                          expression: "keyStatus[key.key_id]",
                                        },
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        type: "checkbox",
                                        id:
                                          "toggle_key" +
                                          _vm.product +
                                          "_" +
                                          key.key_id,
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.keyStatus[key.key_id]
                                        )
                                          ? _vm._i(
                                              _vm.keyStatus[key.key_id],
                                              null
                                            ) > -1
                                          : _vm.keyStatus[key.key_id],
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleKey(key.key_id)
                                        },
                                        change: function ($event) {
                                          var $$a = _vm.keyStatus[key.key_id],
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.keyStatus,
                                                  key.key_id,
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.keyStatus,
                                                  key.key_id,
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.keyStatus,
                                              key.key_id,
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "custom-control-label",
                                        attrs: {
                                          for:
                                            "toggle_key" +
                                            _vm.product +
                                            "_" +
                                            key.key_id,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                #" +
                                            _vm._s(key.key_id) +
                                            " " +
                                            _vm._s(key.key_name) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.programData.info,
                                  function (program, index) {
                                    return program.key == key.key_id &&
                                      program.parent_program_id == 0
                                      ? _c(
                                          "div",
                                          { staticClass: "col-12 view-extras" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "custom-control custom-checkbox",
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.programData.info[
                                                          index
                                                        ].selected,
                                                      expression:
                                                        "programData.info[index].selected",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "custom-control-input",
                                                  attrs: {
                                                    type: "checkbox",
                                                    id:
                                                      "single_upgrade_" +
                                                      _vm.product +
                                                      "_" +
                                                      index,
                                                    name:
                                                      "single_upgrade[" +
                                                      _vm.product +
                                                      "][" +
                                                      program.user_licence_id +
                                                      "]",
                                                  },
                                                  domProps: {
                                                    value: 1,
                                                    checked: Array.isArray(
                                                      _vm.programData.info[
                                                        index
                                                      ].selected
                                                    )
                                                      ? _vm._i(
                                                          _vm.programData.info[
                                                            index
                                                          ].selected,
                                                          1
                                                        ) > -1
                                                      : _vm.programData.info[
                                                          index
                                                        ].selected,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleSingleUpgradeProgram(
                                                        _vm.product,
                                                        index
                                                      )
                                                    },
                                                    change: function ($event) {
                                                      var $$a =
                                                          _vm.programData.info[
                                                            index
                                                          ].selected,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = 1,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              _vm.programData
                                                                .info[index],
                                                              "selected",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              _vm.programData
                                                                .info[index],
                                                              "selected",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          _vm.programData.info[
                                                            index
                                                          ],
                                                          "selected",
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "custom-control-label",
                                                    attrs: {
                                                      for:
                                                        "single_upgrade_" +
                                                        _vm.product +
                                                        "_" +
                                                        index,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        class:
                                                          program.maintenance_excluded
                                                            ? "maintenance_excluded"
                                                            : "",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(program.name) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    program.quantity > 1
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "( " +
                                                              _vm._s(
                                                                program.quantity
                                                              ) +
                                                              " )"
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          program.version
                                                        ) +
                                                        " -> " +
                                                        _vm._s(
                                                          _vm
                                                            .latestProductVersions[
                                                            _vm.product
                                                          ]
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.priceFormat(
                                                            Number(
                                                              _vm.getSingleUpgradePrice(
                                                                program
                                                              ) *
                                                                Number(
                                                                  program.quantity
                                                                )
                                                            ),
                                                            false,
                                                            true
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.programData.info,
                                              function (programModule, index) {
                                                return programModule.key ==
                                                  key.key_id &&
                                                  programModule.parent_program_id ==
                                                    program.id
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-12 view-extras",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "custom-control custom-checkbox",
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .programData
                                                                      .info[
                                                                      index
                                                                    ].selected,
                                                                  expression:
                                                                    "programData.info[index].selected",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "custom-control-input",
                                                              attrs: {
                                                                type: "checkbox",
                                                                id:
                                                                  "single_upgrade_" +
                                                                  _vm.product +
                                                                  "_" +
                                                                  index,
                                                                name:
                                                                  "single_upgrade[" +
                                                                  _vm.product +
                                                                  "][" +
                                                                  programModule.user_licence_id +
                                                                  "]",
                                                                disabled: "",
                                                              },
                                                              domProps: {
                                                                value: 1,
                                                                checked:
                                                                  Array.isArray(
                                                                    _vm
                                                                      .programData
                                                                      .info[
                                                                      index
                                                                    ].selected
                                                                  )
                                                                    ? _vm._i(
                                                                        _vm
                                                                          .programData
                                                                          .info[
                                                                          index
                                                                        ]
                                                                          .selected,
                                                                        1
                                                                      ) > -1
                                                                    : _vm
                                                                        .programData
                                                                        .info[
                                                                        index
                                                                      ]
                                                                        .selected,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.toggleSingleUpgradeProgram(
                                                                      _vm.product,
                                                                      index
                                                                    )
                                                                  },
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        _vm
                                                                          .programData
                                                                          .info[
                                                                          index
                                                                        ]
                                                                          .selected,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c =
                                                                        $$el.checked
                                                                          ? true
                                                                          : false
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v = 1,
                                                                        $$i =
                                                                          _vm._i(
                                                                            $$a,
                                                                            $$v
                                                                          )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .programData
                                                                              .info[
                                                                              index
                                                                            ],
                                                                            "selected",
                                                                            $$a.concat(
                                                                              [
                                                                                $$v,
                                                                              ]
                                                                            )
                                                                          )
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .programData
                                                                              .info[
                                                                              index
                                                                            ],
                                                                            "selected",
                                                                            $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              )
                                                                          )
                                                                      }
                                                                    } else {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .programData
                                                                          .info[
                                                                          index
                                                                        ],
                                                                        "selected",
                                                                        $$c
                                                                      )
                                                                    }
                                                                  },
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "custom-control-label",
                                                                attrs: {
                                                                  for:
                                                                    "single_upgrade_" +
                                                                    _vm.product +
                                                                    "_" +
                                                                    index,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                        " +
                                                                    _vm._s(
                                                                      programModule.name
                                                                    ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      programModule.version
                                                                    ) +
                                                                    " -> " +
                                                                    _vm._s(
                                                                      _vm
                                                                        .latestProductVersions[
                                                                        _vm
                                                                          .product
                                                                      ]
                                                                    ) +
                                                                    " "
                                                                ),
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.priceFormat(
                                                                        Number(
                                                                          _vm.getSingleUpgradePrice(
                                                                            programModule
                                                                          )
                                                                        ),
                                                                        false,
                                                                        true
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e()
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e()
                      }),
                      0
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }